import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeDebuggerService {

  logAll(element: HTMLElement = document.documentElement) {
    const styles = getComputedStyle(element);

    const tokens: Record<string, string> = {};

    // ✅ CSSStyleDeclaration is array-like by index
    for (let i = 0; i < styles.length; i++) {
      const prop = styles[i]; // get property name by index
      if (prop.startsWith('--md-') || prop.startsWith('--mat-') || prop.startsWith('--mat-')) {
        tokens[prop] = styles.getPropertyValue(prop).trim();
      }
    }

    console.clear();
    console.table(tokens);
  }

  get(name: string, element: HTMLElement = document.documentElement) {
    return getComputedStyle(element).getPropertyValue(name).trim();
  }

  trace(...tokens: string[]) {
    tokens.forEach(token => {
      const value = this.get(token);
      console.log(`${token} → ${value}`);
    });
  }
}
